import React from 'react';
import OrderServicesWrapper from './OrderServicesWrapper';
import OrderService from './OrderService';
var OrderServices = function OrderServices(_ref) {
  var orderServices = _ref.orderServices;
  return /*#__PURE__*/React.createElement(OrderServicesWrapper, null, orderServices.map(function (service) {
    return /*#__PURE__*/React.createElement(OrderService, {
      key: service.id || service.key,
      service: service
    });
  }));
};
export default OrderServices;